/* eslint-disable react/prop-types */
import { useEffect, useMemo, useState } from "react";

import { strCode } from "../../../../../../../consts";
import { useFocusOnInput } from "../../../../../../../hooks";

import {
  EditButtonsGroup,
  FlexContainers,
  IconButton,
  Input,
  Paragraph2,
  SVG,
  Switcher,
  WrapperContainer
} from "../../../../../../../components";
import { CellWrapper } from "../../../../../../../components/Table/styled";

export const FeaturesModalTableColumns = [
  {
    Header: strCode.FEATURE_TITLE,
    accessor: "settingName",
    Cell: ({
      cell,
      callbackFn1: getEditingFeature,
      callbackFn2: onCanselEditingFeature,
      callbackFn3: onSavingEditingFeature,
      callbackFn4: onDeletingEditingFeature,
      callbackFn5: onSetEditingFeature,
      callbackFn6: onToggleValue
    }) => {
      const [inputValue, setInputValue] = useState("");

      const isEditing = useMemo(() => {
        const editingFeature = getEditingFeature();

        return Boolean(
          editingFeature && editingFeature.settingName === cell.row.original.settingName
        );
      }, [getEditingFeature, cell]);

      const inputRef = useFocusOnInput(isEditing);

      useEffect(() => {
        if (isEditing) {
          setInputValue(getEditingFeature().settingName);
        }
      }, [isEditing]);

      return (
        <CellWrapper width="100%">
          <WrapperContainer Container={FlexContainers.FlexRowBetween} width="100%">
            <WrapperContainer width="100%">
              {isEditing ? (
                <WrapperContainer maxWidth={300} width="100%">
                  <Input
                    id={cell.row.original.settingName + "-input"}
                    isSmall
                    value={inputValue}
                    placeholder={strCode.FEATURE_PlACEHOLDER}
                    setValue={(value) => setInputValue(value)}
                    innerRef={inputRef}
                  />
                </WrapperContainer>
              ) : (
                <Paragraph2>{cell.value}</Paragraph2>
              )}
            </WrapperContainer>

            <WrapperContainer Container={FlexContainers.FlexRowEnd} width="100%" gap={24}>
              {!isEditing && (
                <IconButton onClick={() => onDeletingEditingFeature(cell.row.original.settingName)}>
                  <SVG.DeleteIcon />
                </IconButton>
              )}

              <WrapperContainer>
                <EditButtonsGroup
                  handleCancel={onCanselEditingFeature}
                  handleAccept={() => onSavingEditingFeature(inputValue)}
                  handleEdit={() => onSetEditingFeature(cell.row.original)}
                  isEdit={!isEditing}
                  disableAccept={
                    !inputValue.length || getEditingFeature()?.settingName === inputValue
                  }
                />
              </WrapperContainer>

              {!isEditing && (
                <Switcher
                  onSwitch={() => onToggleValue(cell.row.original.settingName)}
                  checked={cell.row.original.value}
                  id={cell.row.original.settingName + "-switcher"}
                />
              )}
            </WrapperContainer>
          </WrapperContainer>
        </CellWrapper>
      );
    }
  }
];
